function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#F2F5F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6439 9.28661C20.8903 7.5708 18.0868 7.57117 16.3337 9.28746L8.98078 16.6404C7.65122 18.0013 7.67663 20.1823 9.03753 21.5118C10.376 22.8196 12.5137 22.8196 13.8522 21.5118L20.5104 14.8537C21.376 13.9881 21.376 12.5847 20.5104 11.7191C19.6448 10.8536 18.2414 10.8536 17.3759 11.7191L11.0072 18.0878C10.785 18.3178 10.7914 18.6843 11.0214 18.9064C11.2458 19.1232 11.6015 19.1232 11.8259 18.9064L18.1945 12.5378C18.6168 12.1332 19.2872 12.1476 19.6917 12.5699C20.0841 12.9795 20.0841 13.6255 19.6917 14.035L13.0336 20.6932C12.1341 21.5798 10.6861 21.5695 9.79947 20.67C8.92175 19.7796 8.92175 18.3494 9.79947 17.459L17.1524 10.1061C18.4621 8.7959 20.586 8.79553 21.8962 10.1052C23.2064 11.4149 23.2068 13.5388 21.8971 14.849L14.5441 22.202C14.3013 22.41 14.273 22.7754 14.481 23.0183C14.6889 23.2612 15.0544 23.2895 15.2973 23.0815C15.32 23.0621 15.3411 23.041 15.3605 23.0183L22.7134 15.6654C24.4556 13.8847 24.4245 11.0288 22.6439 9.28661Z",
  fill: "#88959E",
  stroke: "#88959E",
  strokeWidth: 0.4
});

function SvgClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.2dca7543.svg";
export { ForwardRef as ReactComponent };